export const staraShapefileId = 'stara-shapefile';
export const kinzeBluevantageId = 'kinze-bluevantage';

export const ROW_SPACING_MIN = 0;
export const ROW_SPACING_MAX = 1000;
